<template>
    <div class="flex-con xs-pad-lr">
        <div>
            <payment
                :status="order.paymentStatusId"
                :refund="order.paymentRefundStatusId"
                :credit="order.paymentCreditStatusId"
            ></payment>
        </div>
        <div>
            <purchase-order-progress-icon
                :process-status-id="order.purchaseOrderProcessStatusId"
                :failed-status-id="order.purchaseOrderFailedStatusId"
                :canceled-status-id="order.purchaseOrderCanceledStatusId"
                :voided-status-id="order.purchaseOrderVoidedStatusId"
            ></purchase-order-progress-icon>
        </div>
        <div>
            <shipment :status="order.shippedStatusId"></shipment>
        </div>
    </div>
</template>

<script>
import {Payment, PurchaseOrderProgressIcon, Shipment} from './'
export default {
    name : "AllOrderStatusIcons",
    components : {
        Payment,
        PurchaseOrderProgressIcon,
        Shipment,
    },
    props : {
        order : {
            type : Object,
            required : true,
        },
    },
}
</script>

<style scoped>
    .flex-con > div {
        flex:0 0 22px;
    }
    /deep/ .fa {
        font-size:15px;
        line-height:20px;
    }
</style>
